import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      log: 'Log',
      feed: 'Feed',
      handbook: 'Handbook',
      
      // Main tabs
      new: 'New',
      list: 'List',
      sja: 'SJA',
      checks: 'Checks',
      handover: 'Keys',
      documents: 'Docs',
      hub: 'Hub',
      
      // Welcome messages
      welcome: 'Welcome',
      welcome_message: 'Report safety incidents in seconds.',
      
      // Form labels
      title: 'Title',
      author: 'Reporter',
      category: 'Category',
      location: 'Location',
      priority: 'Priority',
      description: 'Description',
      photo: 'Photo',
      evidence: 'Evidence Photo',
      
      // Placeholders
      title_placeholder: "What happened?",
      location_placeholder: "Where did this occur?",
      desc_placeholder: "Describe what happened in detail...",
      author_placeholder: "Your name",
      
      // Actions
      submit: 'Submit Safety Report',
      sending: 'Submitting Report...',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      download: 'Download',
      upload: 'Upload',
      
      // Messages
      new_log: 'New Safety Report',
      error: 'Something went wrong',
      success: 'Success',
      loading: 'Loading...',
      no_data: 'No data available',
      
      // SJA (Safe Job Analysis)
      sja_title: 'Safe Job Analysis (SJA)',
      sja_general_info: 'General Info',
      sja_risk_assessment: 'Risk Assessment',
      sja_review_sign: 'Review & Sign',
      job_name: 'Job Name',
      responsible: 'Responsible',
      participants: 'Participants',
      add_participant: 'Add Participant',
      activity: 'Activity',
      hazards: 'Hazards',
      measures: 'Measures',
      add_risk_item: 'Add Risk Item',
      digital_signature: 'Digital Signature',
      submit_sja: 'Submit SJA',
      
      // Checklists
      checklists: 'Checklists',
      checklist_complete: 'Checklist Complete!',
      good_job: 'Good job.',
      select_procedure: 'Select a procedure to start.',
      submit_checklist: 'Submit Checklist',
      daily_safety_check: 'Daily Safety Check',
      equipment_handover: 'Equipment Handover',
      event_setup: 'Event Setup',
      safety_inspection_desc: 'Standard daily safety inspection checklist',
      equipment_transfer_desc: 'Equipment transfer checklist',
      event_setup_desc: 'Pre-event setup verification',
      check_emergency_exits: 'Check emergency exits are clear',
      verify_fire_extinguishers: 'Verify fire extinguishers are accessible',
      inspect_electrical_panels: 'Inspect electrical panels for damage',
      test_emergency_lighting: 'Test emergency lighting',
      check_first_aid_supplies: 'Check first aid kit supplies',
      equipment_clean_functional: 'Equipment is clean and functional',
      all_accessories_included: 'All accessories are included',
      documentation_complete: 'Documentation is complete',
      serial_numbers_verified: 'Serial numbers verified',
      condition_report_signed: 'Condition report signed',
      stage_setup_complete: 'Stage setup complete',
      sound_system_tested: 'Sound system tested',
      lighting_programmed: 'Lighting programmed',
      safety_barriers_placed: 'Safety barriers in place',
      emergency_procedures_briefed: 'Emergency procedures briefed',
      
      // Handover
      handover_protocol: 'Handover Protocol',
      tenant_name: 'Tenant Name',
      tenant_email: 'Email (for copy)',
      keys_given: 'Keys Given',
      keys_returned: 'Keys Returned',
      electricity_meter: 'Electricity Meter',
      room_inspection: 'Room Inspection / Defects',
      take_photo: 'Take Photo',
      add_observation: 'Add Observation',
      protocol_saved: 'Protocol Saved!',
      download_pdf: 'Download PDF',
      send_email: 'Send Protocol (Email)',
      start_new_protocol: 'Start New Protocol',
      
      // Documents
      documents_library: 'Documents Library',
      upload_manual: 'Upload Manual',
      no_documents: 'No documents found.',
      
      // Arena Integration
      arena_integration: 'Arena Integration Hub',
      arena_description: 'Paste your daily notes. Using tags like project:123 or asset:fail automatically links data.',
      detected_metadata: 'Detected Metadata:',
      ingest_note: 'Ingest Note',
      recent_logs: 'Recent Ingested Logs',
      
      // Mobile Connect
      connect_mobile: 'Connect Mobile Device',
      scan_qr: 'Scan to open Safe App on your phone.',
      same_network: 'Note: Your phone must be on the same Wi-Fi network.',
      
      // Categories
      safety: 'Safety',
      security: 'Security',
      maintenance: 'Maintenance',
      it: 'IT',
      environmental: 'Environmental',
      quality: 'Quality',
      
      // Priorities
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
      
      // Status
      open: 'Open',
      in_progress: 'In Progress',
      resolved: 'Resolved',
      closed: 'Closed',
      
      // Time
      today: 'Today',
      yesterday: 'Yesterday',
      this_week: 'This Week',
      this_month: 'This Month',
      
      // Sync
      sync_external: 'Sync External',
      sync_complete: 'Sync Complete!',
      
      // Theme
      toggle_theme: 'Toggle theme',
      toggle_language: 'Toggle language'
    }
  },
  no: {
    translation: {
      // Navigation
      log: 'Logg',
      feed: 'Feed',
      handbook: 'Håndbok',
      
      // Main tabs
      new: 'Ny',
      list: 'Liste',
      sja: 'SJA',
      checks: 'Sjekk',
      handover: 'Nøkler',
      documents: 'Dok',
      hub: 'Hub',
      
      // Welcome messages
      welcome: 'Velkommen',
      welcome_message: 'Rapporter sikkerhetshendelser på sekunder.',
      
      // Form labels
      title: 'Tittel',
      author: 'Rapportør',
      category: 'Kategori',
      location: 'Lokasjon',
      priority: 'Prioritet',
      description: 'Beskrivelse',
      photo: 'Bilde',
      evidence: 'Bevisbilde',
      
      // Placeholders
      title_placeholder: "Hva skjedde?",
      location_placeholder: "Hvor skjedde dette?",
      desc_placeholder: "Beskriv hva som skjedde i detalj...",
      author_placeholder: "Ditt navn",
      
      // Actions
      submit: 'Send Sikkerhetsrapport',
      sending: 'Sender rapport...',
      cancel: 'Avbryt',
      back: 'Tilbake',
      next: 'Neste',
      save: 'Lagre',
      delete: 'Slett',
      edit: 'Rediger',
      view: 'Vis',
      download: 'Last ned',
      upload: 'Last opp',
      
      // Messages
      new_log: 'Ny Sikkerhetsrapport',
      error: 'Noe gikk galt',
      success: 'Suksess',
      loading: 'Laster...',
      no_data: 'Ingen data tilgjengelig',
      
      // SJA (Safe Job Analysis)
      sja_title: 'Sikker Jobb Analyse (SJA)',
      sja_general_info: 'Generell Info',
      sja_risk_assessment: 'Risikovurdering',
      sja_review_sign: 'Gjennomgang & Signering',
      job_name: 'Jobbnavn',
      responsible: 'Ansvarlig',
      participants: 'Deltakere',
      add_participant: 'Legg til Deltaker',
      activity: 'Aktivitet',
      hazards: 'Farer',
      measures: 'Tiltak',
      add_risk_item: 'Legg til Risikoelement',
      digital_signature: 'Digital Signatur',
      submit_sja: 'Send inn SJA',
      
      // Checklists
      checklists: 'Sjekklister',
      checklist_complete: 'Sjekkliste Fullført!',
      good_job: 'Bra jobbet.',
      select_procedure: 'Velg en prosedyre for å starte.',
      submit_checklist: 'Send inn Sjekkliste',
      daily_safety_check: 'Daglig Sikkerhetssjekk',
      equipment_handover: 'Utstyr Overtakelse',
      event_setup: 'Arrangement Oppsett',
      safety_inspection_desc: 'Standard daglig sikkerhetsinspeksjon sjekkliste',
      equipment_transfer_desc: 'Utstyr overføring sjekkliste',
      event_setup_desc: 'Pre-arrangement oppsett verifisering',
      check_emergency_exits: 'Sjekk at nødutganger er fri',
      verify_fire_extinguishers: 'Verifiser at brannslukningsapparater er tilgjengelige',
      inspect_electrical_panels: 'Inspiser elektriske paneler for skader',
      test_emergency_lighting: 'Test nødbelysning',
      check_first_aid_supplies: 'Sjekk førstehjelpsutstyr',
      equipment_clean_functional: 'Utstyr er rent og funksjonelt',
      all_accessories_included: 'Alt tilbehør er inkludert',
      documentation_complete: 'Dokumentasjon er komplett',
      serial_numbers_verified: 'Serienummer verifisert',
      condition_report_signed: 'Tilstandsrapport signert',
      stage_setup_complete: 'Scene oppsett komplett',
      sound_system_tested: 'Lydsystem testet',
      lighting_programmed: 'Lys programmert',
      safety_barriers_placed: 'Sikkerhetsbarrierer på plass',
      emergency_procedures_briefed: 'Nødprosedyrer gjennomgått',
      
      // Handover
      handover_protocol: 'Overtakelsesprotokoll',
      tenant_name: 'Leietakers Navn',
      tenant_email: 'E-post (for kopi)',
      keys_given: 'Nøkler Utlevert',
      keys_returned: 'Nøkler Returnert',
      electricity_meter: 'Strømmåler',
      room_inspection: 'Rominspeksjon / Mangler',
      take_photo: 'Ta Bilde',
      add_observation: 'Legg til Observasjon',
      protocol_saved: 'Protokoll Lagret!',
      download_pdf: 'Last ned PDF',
      send_email: 'Send Protokoll (E-post)',
      start_new_protocol: 'Start Ny Protokoll',
      
      // Documents
      documents_library: 'Dokumentbibliotek',
      upload_manual: 'Last opp Manual',
      no_documents: 'Ingen dokumenter funnet.',
      
      // Arena Integration
      arena_integration: 'Arena Integrasjonshub',
      arena_description: 'Lim inn dine daglige notater. Bruk av tags som project:123 eller asset:fail kobler automatisk data.',
      detected_metadata: 'Oppdaget Metadata:',
      ingest_note: 'Importer Notat',
      recent_logs: 'Nylige Importerte Logger',
      
      // Mobile Connect
      connect_mobile: 'Koble til Mobil Enhet',
      scan_qr: 'Skann for å åpne Safe App på telefonen din.',
      same_network: 'Merk: Telefonen din må være på samme Wi-Fi nettverk.',
      
      // Categories
      safety: 'Sikkerhet',
      security: 'Sikring',
      maintenance: 'Vedlikehold',
      it: 'IT',
      environmental: 'Miljø',
      quality: 'Kvalitet',
      
      // Priorities
      low: 'Lav',
      medium: 'Middels',
      high: 'Høy',
      critical: 'Kritisk',
      
      // Status
      open: 'Åpen',
      in_progress: 'Pågår',
      resolved: 'Løst',
      closed: 'Lukket',
      
      // Time
      today: 'I dag',
      yesterday: 'I går',
      this_week: 'Denne uken',
      this_month: 'Denne måneden',
      
      // Sync
      sync_external: 'Synkroniser Ekstern',
      sync_complete: 'Synkronisering Fullført!',
      
      // Theme
      toggle_theme: 'Bytt tema',
      toggle_language: 'Bytt språk'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'no', // Default to Norwegian
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;